var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.buttonClass,attrs:{"title":_vm.actor.favourite ? 'Remove from favourites' : 'Add to favourites'},on:{"click":function($event){return _vm.toggleState()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":_vm.actor.favourite ? 'heart' : 'heart-outline',"size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }